









import Vue from 'vue'
import EmojiText from '@/components/EmojiText'
import { FontLoader } from '@/components/FontSelector'
import { SimplecgCSS } from '@/types/layouts'
import './SimplecgElement.scss'

/*
This is a simple box with text in it. Can be used for headlines, etc.
We are calling this 'Simple CG' (Character Generator) instead of just 'Text' or 'Headline',
to match with the term used in the industry for this kind of feature.
*/
export default Vue.extend({
  name: 'SimplecgElement',
  props: {
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    css: {
      type: Object,
      required: false,
      default: () => {{ }}
    },
    rawText: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: () => ({
    defaultcss: new SimplecgCSS(),
    font: 'Dancing Script'
  }),
  computed: {
    // background
    backgroundstyle (): Partial<CSSStyleDeclaration> {
      return {
        backgroundColor: this.getValue('background', 'color'),
        borderRadius: this.getPixelSize('largest', 'background', 'borderradius') + 'px'
      }
    },
    // simple cg content text
    text (): string {
      if (this.rawText) {
          let text: string = this.rawText
          const maxLength = 280
          if (text.length > maxLength) {
              text = text.substring(0, maxLength) + '...'
          }
          return text
      }
      return ''
    },
    textstyle (): Partial<CSSStyleDeclaration> {
      const style: Partial<CSSStyleDeclaration> = {
        left: this.getPixelSize('width', 'text', 'left') + 'px',
        width: this.getPixelSize('width', 'text', 'width') + 'px',
        top: this.getPixelSize('height', 'text', 'top') + 'px',
        fontSize: this.getPixelSize('largest', 'text', 'fontsize') / 3 + 'px',
        fontFamily: this.getFontFamily('text', 'font'),
        color: this.getValue('text', 'color')
      }
      if (!this.getValue('text', 'ltr')) {
        style.direction = 'rtl'
        style['text-align'] = 'right'
      }
      return style
    }
  },
  methods: {
    getFontFamily (component, tag) {
      const font = this.getValue(component, tag)
      if (font) return font + ', Work Sans, Helvetica, Arial, sans-serif'
      return 'Work Sans, Helvetica, Arial, sans-serif'
    },
    getValue (component, tag) {
      let value = (this.defaultcss[component] && this.defaultcss[component][tag])
      if (value === undefined) {
        console.error(`Default CSS for ${component} / ${tag} not existing`)
        value = 0
      }
      if (this.css[component] && this.css[component][tag] !== undefined) {
        value = this.css[component][tag]
      }
      return value
    },
    getPixelSize (direction, component, tag) {
      const value = this.getValue(component, tag)
      if (direction === 'largest') return Math.max(this.height, this.width) * value / 100
      if (direction === 'width') return this.width * value / 100
      if (direction === 'height') return this.height * value / 100
      return 0
    },
    removeEmojis (text) {
      const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
      return text.replace(regex, '')
    }
  },
  components: {
    EmojiText,
    FontLoader
  }
})
